// extracted by mini-css-extract-plugin
module.exports = {"home":"landingPage_home__1akn2","homeButton":"landingPage_homeButton__3N4Oe"};